// extracted by mini-css-extract-plugin
export default {"skeleton-textarea":"pSyq6S"};